<div class="flex flex-col items-center gap-2 p-2">
    <div class="{{message.titleCss}}" *ngIf="message.title !== ''"> {{message.title}} </div>
    <div class="text-center {{message.bodyCss}}" *ngIf="message.body !== ''"> {{message.body}} </div>
    <div class="underline underline-offset-4 text-center text-base {{'text-'+message.clickCss}}"> <a
            href="mailto:equipo.smart@materiagris.pe">equipo.smart&#64;materiagris.pe</a></div>
    <button type="button" class="pt-2 flex items-start" matTooltip="Volver a cargar datos" (click)="emmitAction()">
        <mg-icon iconClass="{{'text-'+message.clickCss}}" iconName="refresh"></mg-icon>
    </button>
</div>